module.exports = __webpack_public_path__ + "media/ask/hand-phone-02-ec539423.svg";